import { Box, Typography, Table, TableBody, CircularProgress } from '@mui/material';
import { createUseStyles } from '@/services/createUseStyles';
import { DraggablePanel } from '@/components/DraggablePanel';
import { Ellipsis } from '@/components/Ellipsis';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import { Asset } from '@/api/generatedApi';
import { AdvancedAnalysisFieldRow } from './AdvancedAnalysisFieldRow';

const useStyles = createUseStyles(theme => ({
  AIAnalysisSidebar_root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
  AIAnalysisSidebar_content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: theme.spacing(2),
  },
  AIAnalysisSidebar_title: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  AIAnalysisSidebar_table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0 1px',
    tableLayout: 'fixed',
  },
  AIAnalysisSidebar_loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
  },
}));

interface AIAnalysisSidebarProperties {
  onWidthChange?: (width: number) => void;
  analysis: Record<string, string>;
  isLoading: boolean;
  asset?: Asset;
}

export const AdvancedAnalysisSidebar = ({ onWidthChange, analysis, isLoading, asset }: AIAnalysisSidebarProperties) => {
  const c = useStyles();

  return (
    <DraggablePanel
      position='right'
      onWidthChange={onWidthChange}
      startingWidth={500}
      mobileProperties={{
        toggleIcon: <AnalyticsIcon />,
        toggleIconContent: <Ellipsis text='AI Analysis' />,
        closeButtonLabel: 'View Analysis',
      }}
    >
      <Box className={c.AIAnalysisSidebar_root}>
        <Box className={c.AIAnalysisSidebar_content}>
          <Typography variant='subtitle1' className={c.AIAnalysisSidebar_title}>
            AI Analysis
          </Typography>
          {isLoading ? (
            <Box className={c.AIAnalysisSidebar_loading}>
              <CircularProgress />
            </Box>
          ) : (
            <Table className={c.AIAnalysisSidebar_table} size='small'>
              <TableBody>
                {Object.entries(analysis).map(([key, value]) => (
                  <AdvancedAnalysisFieldRow key={key} fieldKey={key} value={value} asset={asset} />
                ))}
              </TableBody>
            </Table>
          )}
        </Box>
      </Box>
    </DraggablePanel>
  );
};
